import React from "react"
import { useSelector } from "react-redux"
import { Nav, NavItem, NavLink, TabContent, TabPane, Card } from "reactstrap"
import Spesification from "./tabs/Spesification"
import Skeleton from "react-loading-skeleton"
// import Image from "./Image"

function DetailInspection(props) {
  const store = useSelector(state => state)

  const [active, setActive] = React.useState("1")

  if (store.inspection.rtwOrderSize.loading) {
    return <Skeleton count={5} />
  }

  return (
    <>
      <Nav tabs>
        <NavItem>
          <NavLink
            href="#"
            active={active == "1"}
            onClick={() => setActive("1")}
          >
            仕様
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            active={active == "2"}
            onClick={() => setActive("2")}
          >
            手書き
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={active}>
        <TabPane tabId="1">
          <Spesification />
        </TabPane>
        <TabPane tabId="2">
          <Card body style={{ height: 585 }}>
            {/* <Image handwriting={tempCourselImage} /> */}
          </Card>
        </TabPane>
      </TabContent>
    </>
  )
}

export default DetailInspection
